import { Hide, Show, Stack, useBoolean } from "@chakra-ui/react";
import { createContext } from "react";

import { Welcome } from "./sections/welcome";
import { Experience } from "./sections/experience";
import { Compensation } from "./sections/compensation";
import { BookingInfo } from "./sections/BookingInfo";
import { Contact } from "./sections/contact";
import { LinksModal } from "./sections/LinksModal";
import { Footer } from "./sections/Footer";
import { MobileNav } from "./components/MobNav";
import { Nav } from "./components/WebNav";
import { Gallery } from "./sections/Gallery";
import { Testimonials } from "./sections/Testimonials";

interface VideoContextType {
	hideVideo: boolean;
	setHideVideo: { on: () => void; off: () => void; toggle: () => void };
}

export const VideoContext = createContext<VideoContextType | null>(null);

export const App = () => {
	const pathContainsHash = window.location.href.includes("#");

	const [showLinks, setShowLinks] = useBoolean(!pathContainsHash);
	const [hideVideo, setHideVideo] = useBoolean(!pathContainsHash);

	const viewMeetMePage = () => {
		setHideVideo.off();
		setShowLinks.off();
	};

	return (
		<VideoContext.Provider
			value={{
				hideVideo,
				setHideVideo,
			}}
		>
			<Show below="md">
				<MobileNav />
			</Show>

			<Hide below="md">
				<Nav />
			</Hide>

			<Stack m="0" gap="0" align="center" bg="brand.light">
				<LinksModal isOpen={showLinks} onClose={viewMeetMePage} />

				<Welcome />

				<Stack gap="0" px={{ md: "8" }} maxW={{ md: "1280px" }}>
					<Experience />
					<Compensation />
					<BookingInfo />
					<Testimonials />

					<Show below="md">
						<Gallery />
					</Show>

					<Contact />
				</Stack>

				<Show above="md">
					<Stack gap="8" mt="8" mb="14">
						<Gallery />
						<Footer />
					</Stack>
				</Show>
			</Stack>
		</VideoContext.Provider>
	);
};
